// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".src-features-user-styles-___LoginDisclaimer__LoginDisclaimer___1IcIy .src-features-user-styles-___LoginDisclaimer__container___1nEfI{display:flex;flex-direction:column;position:relative}@media print{.src-features-user-styles-___LoginDisclaimer__LoginDisclaimer___1IcIy .src-features-user-styles-___LoginDisclaimer__container___1nEfI{display:block}}\n", ""]);
// Exports
exports.locals = {
	"LoginDisclaimer": "src-features-user-styles-___LoginDisclaimer__LoginDisclaimer___1IcIy",
	"container": "src-features-user-styles-___LoginDisclaimer__container___1nEfI"
};
module.exports = exports;
